/* eslint-disable */
<template>
    <div id="mainContainer">
      <h1 class="rose audessus"><span>Mentions légales</span></h1>
			<div class="bloc">
        <h3 class="blue">1. Référence du site.</h3>
        <p>
          En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, il est précisé aux utilisateurs du site 
          <a href="https://www.wanview.fr/" title="WANVIEW - www.wanview.fr" target="_blank">www.wanview.fr</a> 
          l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi :
        </p>
        <p>
          Propriétaire : 
          <strong>WANCOM</strong><br>
          54 Av. Georges Pompidou<br>19100 Brive-la-Gaillarde<br>
          SIRET : 43291241800022	                   
        </p>
        <p>
          Responsable de publication : Pierre-Alexandre Cabasse<br />
          Le responsable de publication est une personne physique.
        </p>
        <p>
          Créateur : 
          <a href="https://www.wancom.fr" target="_blank" title="WANCOM - www.wancom.fr">Wancom</a> 54 Av. Georges Pompidou, 19100 Brive la Gaillarde	                    </p>
        <p>
          Webmaster : 
          <a href="https://www.wancom.fr" target="_blank">Wancom</a><br>
          <a href="mailto:contact@wancom.fr" target="_blank">contact@wancom.fr</a>
        </p>
        <p>
          Hébergeur : Amazon – Amazon Web Services Amazon.com Legal Department 410 Terry Avenue North P.O. Box 81226 Seattle, WA 98108-1226 - USA
        </p>
      </div>
      <div class="bloc">
        <h3 class="blue">2. Conditions générales d'utilisation du site et des services proposés.</h3>
        <p>
            L'utilisation du site <a href="https://www.wanview.fr/" title="WANVIEW - www.wanview.fr" target="_blank">www.wanview.fr</a> 
            implique l'acceptation pleine et entière des conditions générales d'utilisation ci-après décrites. 
            Ces conditions d'utilisation sont susceptibles d'être modifiées ou complétées à tout moment, les utilisateurs du site 
            <a href="https://www.wanview.fr/" title="WANVIEW - www.wanview.fr" target="_blank">www.wanview.fr</a> 
            sont donc invités à les consulter de manière régulière.
        </p>
        <p>
            Ce site est normalement accessible à tout moment aux utilisateurs. 
            Une interruption pour raison de maintenance technique peut être toutefois décidée par 
            <a href="https://www.wanview.fr/" title="Wanview - www.wanview.fr" target="_blank">www.wanview.fr</a>, 
            qui s'efforcera alors de communiquer préalablement aux utilisateurs les dates et heures de l'intervention.
        </p>
        <p>
            Le site <a href="https://www.wanview.fr/" title="WANVIEW - www.wanview.fr" target="_blank">www.wanview.fr</a> 
            est mis à jour régulièrement par Pierre-Alexandre Cabasse. 
            De la même façon, les mentions légales peuvent être modifiées à tout moment : 
            elles s'imposent néanmoins à l'utilisateur qui est invité à s'y référer le plus souvent possible afin d'en prendre connaissance.
        </p>
      </div>
      <div class="bloc">
        <h3 class="blue">3. Description des services fournis.</h3>
        <p>
            Le site <a href="https://www.wanview.fr/" title="WANVIEW - www.wanview.fr" target="_blank">www.wanview.fr</a> 
            a pour objet de fournir une information concernant l'ensemble des activités de la société.
        </p>
        <p>
            <a href="https://www.wancom.fr/" target="_blank"><strong>WANCOM</strong></a> s'efforce de fournir sur le site 
            <a href="https://www.wanview.fr/" title="WANVIEW - www.wanview.fr" target="_blank">www.wanview.fr</a> 
            des informations aussi précises que possible.
            Toutefois, il ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, 
            qu'elles soient de son fait ou du fait des tiers equipements qui lui fournissent ces informations.
        </p>
        <p>
            Toutes les informations indiquées sur le site 
            <a href="https://www.wanview.fr/" title="WANVIEW - www.wanview.fr" target="_blank">www.wanview.fr</a> 
            sont données à titre indicatif et sont susceptibles d'évoluer. 
            Par ailleurs, les renseignements figurants sur le site 
            <a href="https://www.wanview.fr/" title="WANVIEW - www.wanview.fr" target="_blank">www.wanview.fr</a> 
            ne sont pas exhaustifs. Ils sont donnés sous réserve de modifications ayant été apportées depuis leur mise en ligne.
        </p>
      </div>
      <div class="bloc">
        <h3 class="blue">4. Limitations contractuelles sur les données techniques.</h3>
        <p>Le site utilise la technologie JavaScript.</p>
        <p>
            Le site Internet ne pourra être tenu responsable de dommages matériels liés à l'utilisation du site. De plus, 
            l'utilisateur du site s'engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus et avec un navigateur de dernière génération mis-à-jour.
        </p>
      </div>
      <div class="bloc">
        <h3 class="blue">5. Propriété intellectuelle et contrefaçons.</h3>
        <p>
             <strong>WANVIEW</strong>
             est propriétaire des droits de propriété intellectuelle ou détient les droits d'usage sur tous les éléments accessibles sur le site, 
            notamment les textes, images, graphismes, logo, icônes, sons, logiciels.
        </p>
        <p>
            Toute reproduction, reréférence, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, 
            est interdite, sauf autorisation écrite préalable de : <strong>WANVIEW</strong>.
        </p>
        <p>
            Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive 
            d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
        </p>
      </div>
      <div class="bloc">
        <h3 class="blue">6. Limitations de responsabilité.</h3>
        <p>
            <strong>WANVIEW</strong> ne pourra être tenue responsable des dommages directs et indirects causés au matériel de l'utilisateur, 
            lors de l'accès au site <strong>WANVIEW</strong>, et résultant soit de l'utilisation d'un matériel ne répondant pas aux spécifications indiquées au point 4, 
            soit de l'apparition d'un bug ou d'une incompatibilité.
        </p>
        <p>
            <strong>WANVIEW</strong> ne pourra également être tenue responsable des dommages indirects (tels par exemple qu'une perte de marché ou perte d'une chance) 
            consécutifs à l'utilisation du site 
            <a href="https://www.wanview.fr/" title="WANVIEW - www.wanview.fr" target="_blank">www.wanview.fr</a>.
        </p>
        <p>
            Des espaces interactifs (possibilité de poser des questions dans l'espace contact) sont à la disposition des utilisateurs. 
            <strong>WANVIEW</strong> se réserve le droit de supprimer, sans mise en demeure préalable, tout contenu déposé dans cet espace qui contreviendrait à la législation
             applicable en France, en particulier aux dispositions relatives à la protection des données. 
            Le cas échéant, <strong>WANVIEW</strong> se réserve également la possibilité de mettre en cause la responsabilité civile et/ou pénale de l'utilisateur, 
            notamment en cas de message à caractère raciste, injurieux, diffamant, ou pornographique, quel que soit le support utilisé (texte, photographie…).
        </p>
      </div>
      <div class="bloc" id="rgpd">
        <h3 class="blue">7. Données personnelles</h3>
        <p>
          En France, les données personnelles sont notamment protégées par la loi n° 78-87 du 6 janvier 1978, la loi n° 2004-801 du 6 août 2004, l'article L. 226-13 du 
          Code pénal et la Directive Européenne du 24 octobre 1995, le règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 et les Dispositions D’adaptation Communes Au Règlement Européen (loi du 14 mai 2018)
        </p>
        <p>
          <strong>Formulaire de contact :</strong><br>
          Les informations recueillies sur le formulaire de contact sont enregistrées dans un fichier et sont destinées au service client.<br>
          Ces données ne sont en aucune manière partagées avec des tiers.
          <span class="spacer"></span>
          <br>
          Conformément aux lois citées ci-dessus, vous pouvez exercer votre droit de suppression et de modification de vos données personnelles en contactant : <span class="spacer"></span>
          <strong>WANVIEW</strong><br>
          54 Av. Georges Pompidou<br>19100 Brive-la-Gaillarde<br>
          <a href="mailto:contact[at]wancom.fr" target="_blank">contact[at]wancom.fr</a><span class="spacer"></span>
        </p>
      </div>
      <div class="bloc">
        <h3 class="blue">8. Liens hypertextes et cookies.</h3>
        <p>
            Le site <a href="https://www.wanview.fr/" title="WANVIEW - https://www.wanview.fr/" target="_blank">www.wanview.fr</a> 
            contient un certain nombre de liens hypertextes vers d'autres sites, mis en place avec l'autorisation de WANVIEW. 
            Cependant, WANVIEW n'a pas la possibilité de vérifier le contenu des sites ainsi visités, et n'assumera en conséquence aucune responsabilité de ce fait.
        </p>
        <p>
            Le refus d'installation d'un cookie peut entraîner l'impossibilité d'accéder à certains services. 
           
        </p>
        <p>
          Nous utilisons Google Analytics pour collecter des informations sur l'utilisation que vous avez du site www.wanview.fr.<br />
         - Pour nous aider à mesurer et étudier l'efficacité de notre contenu interactif en ligne<br />
         - Pour suivre les données analytiques sur le site et l'utilisation faite du site par les utilisateurs<br />
         - Pour améliorer les services du site<br /><br />
        
          Google Analytics collecte les informations sur :<br />
          - Les pages que vous visitez et combien de temps vous passez sur ces pages<br />
          - La manière dont vous êtes arrivé sur le site (site référent, réseaux sociaux, moteur de recherche...)<br />
        </p>
        <p>
             L'utilisateur peut refuser ou accepter l'installation des cookies en utilisant le bouton '<strong>Personnaliser</strong>' situé dans le bandeau.
            L'utilisateur peut également configurer son ordinateur de la manière suivante, pour refuser l'installation des cookies :<br /><br />
        </p>
        <p class="browserComment">
            <u>Pour Microsoft Internet Explorer:</u> <br>
            1. Choisissez le menu "Outils" (ou "Tools ), puis "Options Internet" (ou "Internet Options")<br>
            2. Cliquez sur l'onglet " Confidentialité " (ou " Confidentiality ")<br>
            3. Sélectionnez le niveau souhaité à l'aide du curseur<span class="spacer"></span>
            <u>Pour Mozilla Firefox :</u><br>
            1. Choisissez le menu "Outils" > "Options"<br>
            2. Cliquez sur l'option " Vie Privée "<br>
            3. Rubrique " Cookies "<span class="spacer"></span>
            <u>Pour Chrome:</u> <br>
            1. Choisissez le menu Edition" > "Préférences"<br>
            2. Cliquez sur l'option "Données personnelles"<br>
            3. Rubrique "Cookies"<span class="spacer"></span>
            <u>Pour Safari:</u> <br>
            1. Choisissez le menu "Edition" > "Préférences"<br>
            2. Cliquez sur l'option "Données personnelles"<br>
            3. Rubrique "Cookies"<span class="spacer"></span>
            <u>Pour iOS:</u> <br>
            1. Cliquez sur l'icône "Réglages"<br>
            2. Cliquez sur l'option "Safari"3. Rubrique "CONFIDENTIALITÉ ET SÉCURITÉ"<span class="spacer"></span>
            <u>Pour Android:</u> <br>
            1. Choisissez le menu "Edition" > "Paramètres"<br>
            2. Cliquez sur l'option "Confidentialité et sécurité"<br>
            3. Rubrique "Cookies"<span class="spacer"></span>
            <u>Pour Windows phone:</u> <br>
            1. Choisissez le menu "Edition" > "Préférences"<br>
            2. Cliquez sur l'option "paramètres avancés"<br>
            3. Rubrique "Cookies de sites Web et d'applications"<span class="spacer"></span>
            <u>Pour Chrome mobile:</u> <br>
            1. Choisissez le menu "Edition" > "Paramètres"<br>
            2. Cliquez sur l'option "Confidentialité"<br>
            3. Rubrique "Effacer données navigation"<span class="spacer"></span>
        </p>
                  
        <strong>Liste des cookies utilisés</strong> : <span class="spacer"></span>
                 
        <table id="cookieTable">
          <tr>
               <td><strong>Nom</strong></td>
               <td><strong>Durée</strong></td>
               <td><strong>Émetteur</strong></td>
               <td><strong>Objectif</strong></td> 
          </tr>
          <tr>
               <td>_ga</td>
               <td>13 mois</td>
               <td>Google Analytics</td>
               <td>Différencier les utilisateurs</td> 
          </tr>
          <tr>
            <td>_gat</td>
            <td>10 min</td>
            <td>Google Analytics</td>
            <td>Limitation du taux de demande</td> 
            </tr>
          <tr>
            <td>_gid</td>
            <td>13 mois</td>
            <td>Google Analytics</td>
            <td>Différencier les utilisateurs</td> 
          </tr>
        </table>
      </div>	
      <div class="bloc">
            <h3 class="blue">9. Droit applicable et attribution de juridiction.</h3>
            <p>
                Tout litige en relation avec l'utilisation du site 
                <a href="https://www.wanview.fr/" title="WANVIEW - www.wanview.fr" target="_blank">www.wanview.fr</a> est soumis au droit français. 
                Il est fait attribution exclusive de juridiction aux tribunaux compétents de Paris.
            </p>
      </div>
      <div class="bloc">

            <h3 class="blue">10. Lexique.</h3>
            <p>Utilisateur : Internaute se connectant, utilisant le site susnommé.</p>
            <p>
                Informations personnelles : « les informations qui permettent, sous quelque forme que ce soit, directement ou non, 
                l'identification des personnes physiques auxquelles elles s'appliquent » 
                (article 4 de la loi n° 78-17 du 6 janvier 1978).
            </p>
      </div>  
    </div>
</template>

<script>
export default {
  data() {
    
    return {

    };
  },
  methods: {


    

  },
  mounted() {
  },


};
</script>

<style lang="scss">
@import "../assets/variables.scss";
@import "../styles/mention.scss";
</style>
